export default {
  AppName: 'React JS BoilerPlate',
  APIServer: 'https://jsonplaceholder.typicode.com',
}
